import { render, staticRenderFns } from "./crm-tag-change-log.vue?vue&type=template&id=0cb86dbd&scoped=true&"
import script from "./crm-tag-change-log.vue?vue&type=script&lang=js&"
export * from "./crm-tag-change-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb86dbd",
  null
  
)

export default component.exports